<template>
	<div>
		<b-row class="mb-2">
			<b-col>
				<!-- begin breadcrumb -->
				<!--
				<ol class="breadcrumb float-xl-right">
					<li class="breadcrumb-item active">
						<a href="javascript:;">{{ this.$t('customer_header_name') }}</a>
					</li>
				</ol>
				-->
				<!-- end breadcrumb -->
				<!-- begin page-header -->
				<h1 class="page-header">{{ $t('customer_header_name') }} <!--<small class="ml-2">{{ this.$t('customer_header_small_text') }}</small>--></h1>
				<!-- end page-header -->
			</b-col>
		</b-row>
		<b-row>
			<b-col>
				<page-content-container>
					<router-view 
						:user="user"
						:checkRole="checkRole"
						:customers="customers"
						:customer="customer"
						:status="status"
						:syncCustomersCall="syncCustomersCall"
						:syncDisabled="syncDisabled"
						:showSyncModal="showSyncModal"
						:closeSyncModal="closeSyncModal"
					/>
				</page-content-container>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PageContentContainer from '../components/shared/PageContentContainer'

export default {
	name: 'Customer',
	components: {
		PageContentContainer,
	},
    props: [
		'checkRole',
		'user',
	],
	data() {
		return {
			syncDisabled: false,
			showSyncModal: false,
		}
	},
    computed: {
        ...mapState('customer', ['customers', 'customer', 'status']),
    },
    methods: {
		...mapActions('customer', ['getCustomers', 'getCustomer', 'syncCustomers']),
		syncCustomersCall() {
			this.syncDisabled = true;
			this.syncCustomers();
		},
		closeSyncModal() {
			this.showSyncModal = false;
		},
    },
    filters: {
		toUpperCase(value) {
			value = value.toString();
			return value.toUpperCase();
		}
    },
    mounted() {
		if (!this.customers.length) {
			this.getCustomers();
		}
		if (this.$route.params.id) {
			this.getCustomer(this.$route.params.id);
		}
	},
	watch: {
		customers() {
			if (this.customers && this.customers.sync) {
				this.syncDisabled = false;
				this.showSyncModal = true;
			}
		},
	},
}
</script>
